(function (window, document) {
  'use strict';

  // This is the only browser owner of giveaway attribution. The backend
  // enforces the same allowlist and bounds before persisting the entry.
  function collectAttribution() {
    var attribution = { source: {} };
    var keys = [
      'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
      'campaign_id', 'adset_id', 'ad_id', 'campaign_name', 'adset_name', 'ad_name',
      'placement', 'site_source_name'
    ];
    try {
      var params = new URLSearchParams(window.location.search);
      keys.forEach(function (key) {
        var value = params.get(key);
        if (value === null) return;
        value = value.replace(/[\u0000-\u001f\u007f-\u009f]/g, '').trim().slice(0, 256);
        if (value) attribution.source[key] = value;
      });
      var clickId = params.get('fbclid');
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (clickId && /^[A-Za-z0-9_-]{1,500}$/.test(clickId) && privacy &&
          typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed() === true) {
        attribution.source.fbclid = clickId;
        attribution.attributionConsent = { marketingAllowed: true, source: 'shopify-customer-privacy' };
      }
    } catch (error) { /* Missing attribution or privacy APIs never block entry. */ }
    try {
      var referrer = new URL(document.referrer);
      var page = referrer.origin + referrer.pathname;
      if ((referrer.protocol === 'https:' || referrer.protocol === 'http:') && page.length <= 2048) {
        attribution.source.referrer = page;
      }
    } catch (error) { /* Empty or invalid referrers are not attribution. */ }
    return attribution;
  }

  function initialize(root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    var form = root.querySelector('[data-giveaway-form]');
    var notice = root.querySelector('[data-giveaway-window]');
    var errorNode = root.querySelector('[data-giveaway-error]');
    var successNode = root.querySelector('[data-giveaway-success]');
    var button = root.querySelector('[data-giveaway-submit]');
    var submitLabel = button ? button.textContent : '';
    var opens = Date.parse(root.dataset.opensAt);
    var closes = Date.parse(root.dataset.closesAt);
    var state = 'idle';
    var authoritativeState;
    var advisoryExpiresAt = 0;
    var requestId;
    var fingerprint;
    var widgetId;
    var token = '';
    var siteKey = root.dataset.turnstileSiteKey;
    var fields = ['storeUrl', 'name', 'email', 'phone', 'monthlyOrders', 'whyYou'];
    var consentText = form ? form.elements.consentDisclosureText.value : '';

    function availability() {
      // A fast visitor clock can receive NOT_OPEN just before the real
      // opening. Allow a later manual retry; closure remains authoritative.
      if (authoritativeState === 'upcoming' && Date.now() >= advisoryExpiresAt) authoritativeState = undefined;
      if (authoritativeState) return authoritativeState;
      if (!Number.isFinite(opens) || !Number.isFinite(closes) || closes <= opens) return 'unavailable';
      if (Date.now() >= closes) return 'closed';
      return Date.now() < opens ? 'upcoming' : 'open';
    }

    function updateWindow() {
      if (state === 'submitting' || state === 'confirmed') return;
      var current = availability();
      notice.hidden = current === 'open';
      ['upcoming', 'closed', 'unavailable'].forEach(function (key) {
        root.querySelector('[data-window-' + key + ']').hidden = current !== key;
      });
      if (form) form.hidden = current !== 'open';
      if (button) button.disabled = current !== 'open';
    }

    function showError(message, field) {
      errorNode.textContent = message;
      errorNode.hidden = false;
      if (field && form && form.elements[field]) {
        form.elements[field].setAttribute('aria-invalid', 'true');
        form.elements[field].focus();
      } else {
        errorNode.focus();
      }
    }

    function uuid() {
      if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
      return 'giveaway-' + Date.now() + '-' + Math.random().toString(16).slice(2);
    }

    function trackConfirmed(receipt) {
      // Only the server can qualify the immutable saved entry. Older responses
      // without this decision fail closed; every saved entry still sees success.
      if (receipt.leadEligible !== true) return;
      window.BDMetaPixelQueue = window.BDMetaPixelQueue || [];
      window.BDMetaPixelQueue.push({ type: 'CompleteRegistration', entryId: receipt.entryId, requestId: requestId });
    }

    function resetChallenge() {
      token = '';
      if (window.turnstile && widgetId !== undefined) window.turnstile.reset(widgetId);
    }

    function renderChallenge() {
      if (!siteKey || !form || !window.turnstile || widgetId !== undefined) return;
      widgetId = window.turnstile.render(root.querySelector('[data-giveaway-turnstile]'), {
        sitekey: siteKey,
        callback: function (value) { token = value; },
        'expired-callback': function () { token = ''; },
        'error-callback': function () { token = ''; showError('The security check could not load. Refresh the page and try again.'); }
      });
    }

    if (siteKey && form) {
      if (window.turnstile) renderChallenge();
      else {
        var script = document.querySelector('[data-bd-giveaway-turnstile-script]');
        if (!script) {
          script = document.createElement('script');
          script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
          script.async = true;
          script.dataset.bdGiveawayTurnstileScript = 'true';
          document.head.appendChild(script);
        }
        script.addEventListener('load', renderChallenge);
        script.addEventListener('error', function () { showError('The security check could not load. Refresh the page and try again.'); });
      }
    }

    if (form) form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (state !== 'idle') return;
      updateWindow();
      if (availability() !== 'open' || !form.reportValidity()) return;
      if (siteKey && !token) {
        showError('Complete the security check, then send your entry.');
        return;
      }
      errorNode.hidden = true;
      fields.concat(['agree']).forEach(function (field) { form.elements[field].removeAttribute('aria-invalid'); });
      var entry = collectAttribution();
      fields.forEach(function (field) { entry[field] = form.elements[field].value; });
      entry.agree = form.elements.agree.checked;
      entry.consent = {
        email: true,
        whatsApp: { granted: true, disclosureVersion: 'bf-giveaway-entry-v1' },
        disclosureText: consentText
      };
      var nextFingerprint = JSON.stringify(entry);
      if (fingerprint !== nextFingerprint) {
        fingerprint = nextFingerprint;
        requestId = uuid();
      }
      entry.requestId = requestId;
      if (token) entry.captchaToken = token;
      state = 'submitting';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Sending your entry…';
      try {
        var response = await window.fetch(form.action, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(entry)
        });
        var body = await response.json();
        if (!response.ok || !body || !body.ok || !body.result || !body.result.entryId) {
          if (body && body.code === 'ENTRIES_CLOSED') authoritativeState = 'closed';
          if (body && body.code === 'ENTRIES_NOT_OPEN') {
            authoritativeState = 'upcoming';
            advisoryExpiresAt = Date.now() + 30000;
          }
          showError(body && body.message ? body.message : 'We could not save your entry just now. Please try again.', body && body.field);
          state = 'idle';
          resetChallenge();
          return;
        }
        state = 'confirmed';
        form.hidden = true;
        notice.hidden = true;
        successNode.hidden = false;
        successNode.focus();
        try { trackConfirmed(body.result); } catch (error) { /* Analytics cannot change a saved entry. */ }
      } catch (error) {
        state = 'idle';
        showError('We could not confirm your entry just now. Please try again. Your details are still here.');
        resetChallenge();
      } finally {
        button.setAttribute('aria-busy', 'false');
        button.textContent = state === 'confirmed' ? 'Entry received' : submitLabel;
        updateWindow();
      }
    });

    updateWindow();
    var interval = window.setInterval(function () {
      if (!root.isConnected) { window.clearInterval(interval); return; }
      updateWindow();
    }, 1000);
  }

  document.querySelectorAll('[data-bd-giveaway]').forEach(initialize);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-bd-giveaway]').forEach(initialize);
  });
})(window, document);
